import { getNativeAudioParam } from './get-native-audio-param';
import { renderInputsOfAudioParam } from './render-inputs-of-audio-param';
export var connectAudioParam = function connectAudioParam(context, nativeOfflineAudioContext, audioParam) {
  var nativeAudioParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getNativeAudioParam(audioParam);
  return renderInputsOfAudioParam(context, audioParam, nativeOfflineAudioContext, nativeAudioParam);
};